import React from 'react';
import { Alert } from 'antd';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import { useAuth } from '../../hooks/useAuth';
import { useGetDataQualitySummaryQuery } from '../../services/nestjs-base-api';

interface DataQualitySummaryProps {
    brandHash: string;
}

const DataQualitySummary: React.FC<DataQualitySummaryProps> = ({ brandHash }) => {
    const { user } = useAuth();
    const { data, isLoading } = useGetDataQualitySummaryQuery(
        {
            jwtToken: user?.jwtToken || '',
            organisationId: user?.organisation?.id ?? 0,
            brandHash,
        },
        { skip: !user?.jwtToken || !user?.organisation?.id || !brandHash },
    );

    if (isLoading || !data) return null;
    const total = data.totalCount ?? 0;
    if (total === 0) return null;

    return (
        <Alert
            type="info"
            showIcon
            icon={<SafetyCertificateOutlined />}
            message={
                <FormattedMessage
                    id="responseIntegrity.dataQuality.summary"
                    values={{
                        analysed: data.analysedCount ?? 0,
                        excluded: data.excludedCount ?? 0,
                    }}
                />
            }
            style={{ marginBottom: 16 }}
        />
    );
};

export default DataQualitySummary;
